import { render, staticRenderFns } from "./AddIcon.vue?vue&type=template&id=7c3b657f&scoped=true&"
import script from "./AddIcon.vue?vue&type=script&lang=ts&"
export * from "./AddIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AddIcon.vue?vue&type=style&index=0&id=7c3b657f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3b657f",
  null
  
)

export default component.exports